import React from 'react';
import { REPUTATION_DEFAULT_LABEL_BY_SUB_TYPE } from '@reach/shared-types/automation-template';
import type { ReputationDefaultTemplate } from './reputation-defaults-api';
import {
  ADDED_LABEL,
  NO_DEFAULT_TEMPLATES_LABEL,
  SELECT_ALL_LABEL,
  TEMPLATE_LOADING_LABEL,
  TEMPLATE_SELECTION_HEADING,
} from './reputation-defaults.constants';
import styles from './reputation-defaults-dialog.module.css';

interface TemplateSelectionStepProps {
  /** Undefined while the defaults are still being fetched. */
  templates: ReputationDefaultTemplate[] | undefined;
  selectedNames: string[];
  onToggleTemplate: (name: string) => void;
  onToggleAll: () => void;
}

export const TemplateSelectionStep: React.FC<TemplateSelectionStepProps> = ({
  templates,
  selectedNames,
  onToggleTemplate,
  onToggleAll,
}) => {
  const isLoading = templates === undefined;
  const loadedTemplates = templates ?? [];
  const addableTemplates = loadedTemplates.filter(template => !template.alreadyAdded);
  const everyAddableIsSelected =
    addableTemplates.length > 0 && selectedNames.length === addableTemplates.length;

  return (
    <fieldset className={styles.templateList}>
      <legend className={styles.stepHeading}>{TEMPLATE_SELECTION_HEADING}</legend>

      {isLoading && <p className={styles.emptyState}>{TEMPLATE_LOADING_LABEL}</p>}
      {!isLoading && loadedTemplates.length === 0 && (
        <p className={styles.emptyState}>{NO_DEFAULT_TEMPLATES_LABEL}</p>
      )}

      {addableTemplates.length > 0 && (
        <label className={styles.selectAll}>
          <input type="checkbox" checked={everyAddableIsSelected} onChange={onToggleAll} />
          {SELECT_ALL_LABEL}
        </label>
      )}

      {loadedTemplates.map(template => (
        <label key={template.name} className={styles.templateOption}>
          <input
            type="checkbox"
            checked={selectedNames.includes(template.name)}
            disabled={template.alreadyAdded}
            onChange={onToggleTemplate.bind(null, template.name)}
          />
          {template.featureSubType
            ? REPUTATION_DEFAULT_LABEL_BY_SUB_TYPE[template.featureSubType]
            : template.displayName}
          {template.alreadyAdded && <span className={styles.addedPill}>{ADDED_LABEL}</span>}
        </label>
      ))}
    </fieldset>
  );
};
